module.exports = __webpack_public_path__ + "static/img/1.5284954.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/1.png
// module id = VhT2
// module chunks = 0